import React, { useContext, useEffect, useState } from 'react';
import { mediaQueries } from '../../../../play-core/styles/Viewports';
import { jsx as _jsx } from "react/jsx-runtime";
const initialState = {
  small: false,
  medium: false,
  large: false,
  mediumUp: false,
  mediumDown: false,
  largeUp: false,
  xLargeUp: false
};
export const ViewportStateContext = /*#__PURE__*/React.createContext(initialState);
export const ViewportProvider = ({
  children
}) => {
  const [state, setState] = useState(initialState);
  const viewportHandler = event => {
    if (event.matches) {
      setState(getCurrentState());
    }
  };
  useEffect(() => {
    // Safari 13 does not yet support addEventListener, so we keep using the old API for now.
    window.matchMedia(mediaQueries.small).addListener(viewportHandler);
    window.matchMedia(mediaQueries.medium).addListener(viewportHandler);
    window.matchMedia(mediaQueries.large).addListener(viewportHandler);
    window.matchMedia(mediaQueries.xLargeUp).addListener(viewportHandler);
    setState(getCurrentState());

    // Returning a cleanup function here results in a "Cannot read property 'createEvent' of null"
    // error when running the unit tests. The reasons are unknown, but luckily it's ok not to cleanup here
    // as the ViewportContext is only ever instantiated once during the lifetime of the Play app.
  }, []);
  return /*#__PURE__*/_jsx(ViewportStateContext.Provider, {
    value: state,
    children: children
  });
};
const getCurrentState = () => ({
  small: window.matchMedia(mediaQueries.small).matches,
  medium: window.matchMedia(mediaQueries.medium).matches,
  mediumUp: window.matchMedia(mediaQueries.mediumUp).matches,
  mediumDown: window.matchMedia(mediaQueries.mediumDown).matches,
  large: window.matchMedia(mediaQueries.large).matches,
  largeUp: window.matchMedia(mediaQueries.largeUp).matches,
  xLargeUp: window.matchMedia(mediaQueries.xLargeUp).matches
});
export const useViewportState = () => {
  const context = useContext(ViewportStateContext);
  if (context === undefined) {
    throw new Error('useViewportState must be used within a ViewportProvider');
  }
  return context;
};
export const useViewport = () => {
  const viewports = useViewportState();
  return {
    isSmall: viewports.small,
    isMedium: viewports.medium,
    isMediumUp: viewports.mediumUp,
    isMediumDown: viewports.mediumDown,
    isLarge: viewports.large,
    isLargeUp: viewports.largeUp,
    isXLargeUp: viewports.xLargeUp
  };
};